<template>
  <el-container v-loading="loading" class="outer">
    <el-container>
      <el-header>
        <el-row style="margin-top: 20px; margin-left: 10px">
          <el-col :span="24">
            <span>当前目录信息和层级关系</span>
            <el-select v-model="orderKey" placeholder="请选择" size="middle" style="margin-left: 10px;vertical-align: middle;" @change="catalogChange" >
              <el-option v-for="(item, index) in orderRuleList" :key="index" :label="item.orderName" :value="item.orderCode" >
            </el-option> </el-select
          ></el-col>
        </el-row>
      </el-header>
      <el-container>
        <el-main>
          <el-card v-for="(item, key) in data" :key="key" class="box-card" shadow="hover" >
            <div slot="header" class="clearfix">
              <span>包含{{ item.name }}</span>
              <el-button type="text" icon="el-icon-plus" style="color:#3873fe!important" @click="addItem(item, key)" >新增{{ item.name }}</el-button >
            </div>
            <div v-for="(child, index) in item[item.key + 'List']" :key="index" class="item" >
              <span class="content">
                <span :title="child[item.key + 'Name']" class="text">{{ child[item.key + "Name"] }}</span>
                <span v-if="child.isActive === 1" class="danger">已禁用</span>
              </span>
              <el-button :disabled="child.orderNum === 1" type="text" style="color:#3873fe" @click="move(index, item, 'up')" >上移</el-button >
              <el-button :disabled="child.orderNum === item[item.key + 'List'].length" type="text" style="color:#3873fe" @click="move(index, item, 'down')" >下移</el-button >
              <el-button style="color:#3873fe!important" type="text" @click="toggleDisabled(child)">{{ child.isActive ? "启用" : "禁用" }}</el-button>
              <el-button v-if="item.name === '子项'" :disabled="child.isPublish === 1" type="text" style="color:#3873fe!important" @click="editChild(child[item.key + 'Name'], index, key,child.childId)" >编辑</el-button >
              <el-button :disabled="child.isPublish === 1" type="text" @click="delChild(item, index)" style="color:#EE7171!important" >删除</el-button >
            </div>
          </el-card>
        </el-main>
        <el-footer >
          <el-button :loading="rollbackLoading" :disabled="catalogInit === '0'" type="info" @click="rollback" >恢复至最后一次发布状态</el-button >
          <el-button :loading="saveChangeLoading" type="primary" @click="saveChange('')" >保存更改</el-button >
          <el-button :loading="publishChangeLoading" type="primary" @click="publishChange" >发布</el-button >
        </el-footer>
      </el-container>
    </el-container>
    <el-aside width="250px" style="position: relative;">
      <preview-tree :tree-data="data" :csget-params="csgetParams"></preview-tree>
    </el-aside>
    <el-dialog :visible.sync="professionDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="添加专业" custom-class="profession-dialog" destroy-on-close width="500px" >
      <el-form ref="form" :model="form" label-position="top">
        <el-row>
          <el-col :span="24">
            <el-form-item label="选择专业">
              <el-select v-model="form.spec" placeholder="请选择" size="middle" style="width: 100%" value-key="specId" multiple >
                <el-option v-for="(item, inedx) in filteredSpecList" :key="inedx" :label="item.specName" :value="item" >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="professionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit('spec')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="childDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="添加子项" custom-class="profession-dialog" destroy-on-close width="500px" >
      <el-form ref="childform" :model="form" label-position="top">
        <el-row>
          <el-col :span="24">
            <el-form-item label="请输入子项名称">
              <el-input v-model="form.child" maxlength="80" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="childDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit('child')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="stageDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="添加阶段" custom-class="profession-dialog" destroy-on-close width="500px" >
      <el-form ref="form" :model="form" label-position="top">
        <el-row>
          <el-col :span="24">
            <el-form-item label="选择阶段">
              <el-select v-model="form.stage" placeholder="请选择" size="middle" style="width: 100%" value-key="stageId" multiple >
                <el-option v-for="(item, index) in filteredStageList" :key="index" :label="item.stageName" :value="item" >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="stageDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit('stage')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="catalogDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="关键目录维护" custom-class="profession-dialog" width="500px" >
      <el-form ref="form" :model="form" label-position="top">
        <el-row>
          <el-col :span="24">
            <el-form-item label="请先选择您想要的目录信息和层级关系">
              <el-select v-model="orderKey" placeholder="请选择" size="middle" style="width: 100%" @change="catalogChange" >
                <el-option v-for="(item, index) in orderRuleList" :key="index" :label="item.orderName" :value="item.orderCode" >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="catalogDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="initCatalog">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import service from "@/CommonDP/service/folder-service";
import PreviewTree from "./previewTree.vue";

export default {
  components: { PreviewTree },
  data() {
    return {
      loading: false,
      rollbackLoading: false,
      saveChangeLoading: false,
      publishChangeLoading: false,
      catalogDialogVisible: false,
      professionDialogVisible: false,
      childDialogVisible: false,
      stageDialogVisible: false,
      orderRuleList: [],
      orderKey: "",
      directoryStatus: null,
      selectedOrderKey: "",
      data: [],
      specList: [],
      stageList: [],
      curItem: null,
      curEditIndex: -1,
      form: {
        spec: [],
        stage: [],
        child: ""
      },
      csgetParams: {},
      curEditId:""
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      catalogInit: state => state.projectMg.catalogInit,
      enterpriseId: state => state.enterprise.enterpriseId,
    }),
    filteredSpecList() {
      // 过滤已添加的数据
      if (!this.data.length) return this.specList;
      const index = this.data.findIndex(item => item.key === "spec");
      if (index < 0) return [];
      if (!this.data[index].specList.length) return this.specList;
      return this.specList.filter(item => {
        return !this.data[index].specList.map(d => d.specId).includes(item.specId); });
    },
    filteredStageList() {
      // 过滤已添加的数据
      if (!this.data.length) return this.stageList;
      const index = this.data.findIndex(item => item.key === "stage");
      if (index < 0) return [];
      if (!this.data[index].stageList.length) return this.stageList;
      return this.stageList.filter(item => {
        return !this.data[index].stageList.map(d => d.stageId).includes(item.stageId);
      });
    }
  },
  watch: {
    directoryStatus(newValue) {
      if (newValue === "0") this.catalogDialogVisible = true;
      if (newValue === "2") this.setCatalogToken("1");
      this.csgetParams = this.getParams()
    },
    prjInfo() {
      this.fetchData();
    }
  },
  created() {
    this.queryAllDic();
    this.fetchData();
  },
  methods: {
    ...mapActions(["setCatalogToken"]),
    initCatalog() {
      this.saveChange("init");
      this.catalogDialogVisible = false;
    },
    catalogChange() {
      if (this.catalogInit === "1") {
        this.$message.warning("目录已经发布，不能修改");
        this.orderKey = this.selectedOrderKey;
      } else {
        this.saveChange("init");
      }
    },
    fetchData() {
      this.loading = true;
      service.queryKeyCatalogList({ prjId: this.prjInfo.prjId }).then(res => {
        this.loading = false;
        if (res.result === "0") {
          const { orderRuleList, orderKey, directoryStatus, orderRule = [] } = res.data;
          this.$set(res.data, "childItemlist", res.data.childList);
          this.orderRuleList = orderRuleList;
          this.orderKey = orderKey;
          this.selectedOrderKey = orderKey;
          this.directoryStatus = directoryStatus;
          this.data = orderRule.map(rule => {
            return {
              ...rule,
              [rule.key + "List"]: res.data[rule.key + "List"]
            };
          });
        }
      }).catch(()=>{
        this.loading = false;
      });
    },
    queryAllDic() {
      const params = { enterpriseId: this.enterpriseId };
      service.queryspeclist2(params).then(res => {
        this.specList = res.data;
      });
      service.queryStageList(params).then(res => {
        this.stageList = res.data;
      });
    },
    getParams() {
      const stageFiltered = this.data.filter(item => item.key === "stage");
      const specFiltered = this.data.filter(item => item.key === "spec");
      const childItemFiltered = this.data.filter(item => item.key === "child");
      const params = {
        enterpriseId: this.enterpriseId,
        orderKey: this.orderKey,
        prjId: this.prjInfo.prjId,
        stageList: stageFiltered.length ? stageFiltered[0].stageList || [] : [],
        specList: specFiltered.length ? specFiltered[0].specList || [] : [],
        childList: childItemFiltered.length ? childItemFiltered[0].childList || [] : []
      };
      return params;
    },
    publishChange() {
      if (this.directoryStatus === "0") {
        this.$message.warning("请先初始化目录");
        return;
      }
      this.publishChangeLoading = true;
      const params = this.getParams();
      this.csgetParams = this.getParams();
      var tt=this.csgetParams.orderKey.split('>').every(item => {
        return this.csgetParams[item + "List"].length>0
      });
      if(tt){
        service.publishChange(params).then(res => {
          this.publishChangeLoading = false;
          if (res.result === "0") {
            this.$parent.fabutipsshow = false
            this.$message.success("发布成功");
            this.fetchData();
          }
        }).catch(()=>{
          this.publishChangeLoading = false;
        })
      }else{
        var item=this.csgetParams.orderKey.split('>')
        for(var i=0;i<item.length;i++){
          if(!this.csgetParams[item[i] + "List"].length){
            if(item[i]==='child'){
              this.$message.warning("子项不能为空");
              this.publishChangeLoading = false;
              break;
            }else if(item[i]==='stage'){
              this.$message.warning("阶段不能为空");
              this.publishChangeLoading = false;
              break;
            }else if(item[i]==='spec'){
              this.$message.warning("专业不能为空");
              this.publishChangeLoading = false;
              break;
            }
          }
        }
      }
    },
    saveChange(type) {
      this.saveChangeLoading = true;
      const params = this.getParams();
      this.csgetParams = this.getParams();
      service.saveChange(params).then(res => {
        this.saveChangeLoading = false;
        if (res.result === "0") {
          if (!type) this.$message.success("保存成功");
          this.fetchData();
        }
      }).catch(()=>{
        this.saveChangeLoading = false;
      });
    },
    rollback() {
      if (this.directoryStatus !== "1") {
        this.$message.warning("暂无要恢复的数据");
        return;
      }
      this.rollbackLoading = true;
      service.rollback({ prjId: this.prjInfo.prjId }).then(res => {
        this.rollbackLoading = false;
        if (res.result === "0") {
          this.$parent.fabutipsshow = false
          this.$message.success("恢复成功");
          this.fetchData();
        }
      }).catch(()=>{
        this.rollbackLoading = false;
      });
    },
    addItem({ key }, index) {
      this.curItem = index;
      this.curEditId='';
      this.curEditIndex=-1;
      switch (key) {
        case "spec":
          this.professionDialogVisible = true;
          break;
        case "child":
          this.childDialogVisible = true;
          this.form.child = "";
          break;
        case "stage":
          this.stageDialogVisible = true;
          break;
        default:
          this.professionDialogVisible = true;
          break;
      }
    },
    submit(type) {
      this.$parent.queryfabutips('2')
      const num = this.data[this.curItem][type + "List"].length + 1;
      const enterpriseId = this.enterpriseId;
      const common = {
        prjId: this.prjInfo.prjId,
        isActive: 0,
        orderNum: num,
        isDelete: 0,
        enterpriseId,
        isOutSpec: ""
      };
      switch (type) {
        case "child":
          this.updateChildItem(common, type);
          break;
        case "spec":
          this.updateSpec(common, type, num);
          break;
        case "stage":
          this.updateStage(common, type, num);
          break;
      }
    },
    updateSpec(common, type, orderNum) {
      if (!this.form[type].length) {
        this.$message.warning("请先选择专业");
        return;
      }
      this.form[type].forEach(item => {
        this.data[this.curItem][type + "List"].push({
          [type + "Id"]: item.specId,
          [type + "Name"]: item.specName,
          ...common,
          orderNum: orderNum++
        });
      });
      this.form.spec = [];
      this.professionDialogVisible = false;
      this.csgetParams = this.getParams()
    },
    updateChildItem(common, type) {
      if (!this.form[type]) {
        this.$message.warning("请先输入子项名称");
        return;
      }
      var regExp = new RegExp("^[\u4e00-\u9fa5_a-zA-Z0-9!@#$^&().']+$");
      if (!regExp.test(this.form[type])) {
        this.$message.warning("子项名称不能包含以下字符:\ / : * ? < > | ");
        return;
      }
      if(this.form[type].length>80){
        this.$message.warning("子项名称最多80字符");
        return;
      }
      const has = this.data[this.curItem][type + "List"].some(
        item => item.childName === this.form[type]&&item.childId !== this.curEditId
      );
      if (has) {
        this.$message.warning("当前子项已存在");
        return;
      }
      if (this.curEditIndex > -1) {
        // 编辑子项
        this.data[this.curItem][type + "List"][
          this.curEditIndex
        ].childName = this.form[type];
        this.curEditIndex = -1;
        this.form.child = "";
        this.childDialogVisible = false;
        return;
      }
      common = {
        childName: this.form[type],
        childId: this.form[type],
        ...common
      };

      this.data[this.curItem][type + "List"].push(common);
      this.form.child = "";
      this.childDialogVisible = false;
      this.csgetParams = this.getParams()
    },
    updateStage(common, type, orderNum) {
      if (!this.form[type].length) {
        this.$message.warning("请先选择阶段");
        return;
      }

      this.form[type].forEach(item => {
        this.data[this.curItem][type + "List"].push({
          [type + "Id"]: item.stageId,
          [type + "Name"]: item.stageName,
          ...common,
          orderNum: orderNum++
        });
      });
      this.form.stage = [];
      this.stageDialogVisible = false;
      this.csgetParams = this.getParams()
    },
    move(index, data, direction) {
      const key = data.key + "List";
      const temp = data[key].splice(index, 1)[0];
      if (direction === "up") {
        data[key].splice(index - 1, 0, temp);
      } else {
        data[key].splice(index + 1, 0, temp);
      }
      this.$parent.queryfabutips('2');
      // 点击上下移以后 查询一下当前数据 防止点击预览 数据不是最新的
      this.csgetParams = this.getParams();
      this.dataSort(data, key);
    },
    toggleDisabled(child) {
      this.$parent.queryfabutips('2');
      // 点击禁用 启用以后 查询一下当前数据 防止点击预览 数据不是最新的
      this.csgetParams = this.getParams();
      child.isActive = 1 - (child.isActive || 0);
    },
    editChild(name, index, key,childId) {
      this.curItem = key;
      this.form.child = name;
      this.curEditIndex = index;
      this.curEditId = childId;
      this.childDialogVisible = true;
    },
    delChild(data, index) {
      this.$confirm("确认要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 点击删除以后 查询一下当前数据 防止点击预览 数据不是最新的
        this.csgetParams = this.getParams();
        data[data.key + "List"].splice(index, 1);
        this.dataSort(data, data.key + "List");
        this.$parent.queryfabutips('2')
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      });
    },
    dataSort(data, key) {
      data[key].forEach((ele, index) => (ele.orderNum = index + 1));
    },
  }
};
</script>

<style lang="scss" scoped>
.el-container.outer {
  height: calc(100% + 20px);
  margin: -10px -32px -10px -20px;
  .el-container {
    height: 100%;
    .el-container {
      height: calc(100% - 60px);
      .el-main {
        height: 100%;
        display: flex;
        /deep/ .el-card {
          width: 33%;
          margin: 10px;
          min-width: 320px;
          max-height: calc(100% - 22px);
          &__header {
            padding: 5px;
            background-color: rgb(232, 240, 254);
            .clearfix {
              text-align: center;
              & > span {
                position: relative;
                top: 5px;
                left: 40px;
              }
              .el-button {
                float: right;
              }
            }
          }
          &__body {
            max-height: calc(100% - 80px);
            overflow: auto;
            .item {
              border-bottom: 1px solid #ebeef5;
              padding: 8px 0 3px;
              display: flex;
              .content {
                width: 63%;
                display: flex;
                font-size: 15px;
                .danger {
                  color: #f56c6c;
                }
                .text {
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 100px;
                  margin-right: 10px;
                }
              }
              .el-button {
                padding: 0 !important;
                position: relative;
                top: -5px;
                font-size: 10px;
                margin-left: 8px;
              }
            }
          }
        }
      }
      .el-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
  .el-aside {
    border-left: 1px solid rgb(235, 239, 255);
    .el-card {
      border: none;
      height: calc(100% - 5px);
      border-radius: 0;
      &__header {
        .clearfix {
          text-align: center;
          & > span {
            position: relative;
            top: 5px;
            left: -18px;
          }
          .el-button {
            float: left;
          }
        }
      }
      &__body {
        height: calc(100% - 100px);
        overflow: auto;
      }
    }
  }
  /deep/ .profession-dialog {
    border-radius: 5px;
    .el-dialog__body {
      padding: 20px;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
    }
  }
}
</style>
